import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Compte admin fixe
  const ADMIN_EMAIL = 'hervekwengoua@gmail.com';
  const ADMIN_PASSWORD = 'WgikQà@#2E1ppZ';
  const ADMIN_NAME = 'Administrateur';

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté au chargement
    const storedUser = localStorage.getItem('moov4goods_user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        localStorage.removeItem('moov4goods_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Vérifier les identifiants admin
    if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      const userToStore = { 
        id: 'admin', 
        email: ADMIN_EMAIL, 
        name: ADMIN_NAME 
      };
      localStorage.setItem('moov4goods_user', JSON.stringify(userToStore));
      setUser(userToStore);
      return userToStore;
    }

    throw new Error('Email ou mot de passe incorrect');
  };

  const logout = () => {
    localStorage.removeItem('moov4goods_user');
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
